import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CST_LOCALSTORAGE_VALUE } from 'src/app/classes/const';
import { Chantier } from 'src/app/classes/json-interface';
import { g_params } from 'src/app/classes/global-param';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'site-selector',
  templateUrl: './site-selector.component.html',
  styleUrls: ['./site-selector.component.css']
})
export class SiteSelectorComponent implements OnInit {

  // TODO : 02/06/2021 - Faire du nettoyage sur le composant
  @Input('disabled') mForceDisabled: boolean = false;           // Désactive la selection du code chantier
  @Input('selectedSiteCode') lastSelectedSiteCode: string = ''; // Indique le dernier site code que l'on souhaite afficher, doit fonctionner de paire avec disabled
  @Input('sync') mSyncSiteSelector: boolean = true;             // Enregistre à chaque modification du chantie le nouveau code chantier dans le sessions storage
  @Output('onSiteCodeChange') mOnSiteChange = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void { }

  /**
   * Appeler depuis le HTML, gere le changement de chantier
   * @param newSiteCode Nouveau code chantier
   */
  onSiteChange(newSiteCode: string, event: any) {
    if (this.mSyncSiteSelector)
      sessionStorage.setItem(CST_LOCALSTORAGE_VALUE.SelectedSiteCode, newSiteCode);
    this.mOnSiteChange.emit(newSiteCode); // Alerte du changement de chantier
  }

  get isDisabled(): boolean {
    return (g_params.g_arraySite && g_params.g_arraySite.length <= 1) || this.mForceDisabled;
  }

  get HTML_SelectSiteCode(): string {
    // Quand on à désactiver le select on retourne seulement le dernier site code enregistrer sur le composant
    if (this.mForceDisabled && this.lastSelectedSiteCode != '')
      return this.lastSelectedSiteCode;
    else if (!this.mSyncSiteSelector && this.lastSelectedSiteCode != '')
      return this.lastSelectedSiteCode;
    // Evenement si le code chantier a changé
    this.lastSelectedSiteCode = (sessionStorage.getItem(CST_LOCALSTORAGE_VALUE.SelectedSiteCode) || '');
    return this.lastSelectedSiteCode;
  }

  get HTML_ARRAY_SITE() : Chantier[] {
    return g_params.g_arraySite;
  }
}
